import { PayloadAction, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';

import { Comment } from 'app/model/comment';
import { StoreMetric } from 'app/model/metrics/store-metric';
import { ToplineMetric } from 'app/model/metrics/topline-metric';
import { SeamPattern } from 'app/model/seam-pattern';
import { SeamRequest } from 'app/model/seam-request';
import { ModelWithoutId } from 'app/type/model-with-id';

import { SeamRdxState } from './seam-rdx-state';

export const reducers: ValidateSliceCaseReducers<SeamRdxState, SliceCaseReducers<SeamRdxState>> = {
    selectRequest: (state, action: PayloadAction<SeamRequest | undefined>) => {
        if (state.selectedRequest?.id !== action.payload?.id) {
            // if request changed we need to clear old patterns they'll get reloaded as needed
            state.seamPatterns = undefined;
        }
        state.selectedRequest = action.payload;
    },
    selectPattern: (state, action: PayloadAction<ModelWithoutId<SeamPattern> | undefined>) => {
        if ('new' === action.payload?.id) {
            delete action.payload.id;
        }
        state.selectedPattern = action.payload;
    },
    setSeamComments: (state, action: PayloadAction<Comment[]>) => {
        state.seamComments = action.payload;
    },
    setSeamPatterns: (state, action: PayloadAction<SeamPattern[] | undefined>) => {
        if (!action.payload) {
            state.seamPatterns = undefined;

            return;
        }
        state.seamPatterns = action.payload.sort((a, b) => a.position - b.position);
    },
    setOverallMetrics: (state, action: PayloadAction<ToplineMetric[]>) => {
        state.overallMetrics = action.payload;
    },
    setStoreMetrics: (state, action: PayloadAction<StoreMetric[]>) => {
        state.storeMetrics = action.payload;
    },
    setStoreGraphMetrics: (state, action: PayloadAction<StoreMetric[] | undefined>) => {
        state.storeGraphMetrics = action.payload;
    },
};
